export enum Role {
  TokenAgent = 'tokenAgent',
  IdentityAgent = 'identityAgent',
  TokenOwner = 'tokenOwner',
  IdentityOwner = 'identityOwner',
  ComplianceOwner = 'complianceOwner',
  StorageOwner = 'storageOwner',
  ClaimTopicsOwner = 'claimTopicsOwner',
  TrustedIssuersOwner = 'trustedIssuersOwner',
  DVDOwner = 'dvdOwner',
  ImplementationAuthorityOwner = 'implementationAuthorityOwner',
}
